import styled from 'styled-components'

export const TextCaptionContainer = styled.div`
  position: absolute;
  transition: 0.15s;

  &>p>span>span span{
        text-decoration: ${props => props.underline}; 
    }

    &>p span{
        /* margin: 0px -0.005em; */
        margin: ${props => props.textDirection === 'rtl' ? '0px' : '0px -0.005em'};
        /* margin: 0px -0.1px; */
        /* из-за этого трансишена при анимации слова переливаются как гирлянда */
        /* transition: all .3s ease; */
        
    }
    
    & .Typewriter__cursor{
      position:absolute;
    }

    & p.showTextAnyway span {
        visibility: visible !important;
        opacity: 1 !important;
    }

    ul.texts {
      ${props => props.slideJustTranspiled ? 'display: block !important; visibility: hidden; height: 0;' : ''}
    }

    &:hover{
        & p{
            color:${props => props.isHover ? props.fontColorHover : props.animationIn === 'stripes' ? '' : props.color} !important;
            background-color:${props => props.isHover ? props.backgroundColorHover : props.animationIn === 'stripes' ? '' : props.backgroundColor} !important;
            border-color:${props => props.isHover ? props.borderColorHover : props.borderColor} !important;
        }
    }

    &::after {
      content: ${props => props.hasAfter ? '""' : ''};
      background-color: ${props => props.backgroundColor};
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: -1;
      transition: .2s;
      border-radius: ${props => props.borderRadius}px;
    }
    &:hover::after {
      background-color: ${props => props.isHover ? props.backgroundColorHover : props.animationIn === 'stripes' ? '' : props.backgroundColor} !important;
    }

    @keyframes animated-text {
    100% {
      background-position: 200% 0;
    }
  }

  .text-caption:hover{
            color:${props => props.isHover ? props.fontColorHover : props.animationIn === 'stripes' ? '' : props.color} !important;
            background-color:${props => props.isHover ? props.backgroundColorHover : props.animationIn === 'stripes' ? '' : props.backgroundColor} !important;
            border-color:${props => props.isHover ? props.borderColorHover : props.borderColor} !important;
    }

  .stripes-animation span{
    background: ${props => props.stripesColor ? `${props.stripesColor} text` : `linear-gradient(90deg, rgba(255, 78, 78, 1) 0%, rgba(255, 159, 67, 1) 20%, rgba(112, 251, 168, 1) 40%, rgba(76, 144, 253, 1) 60%, rgba(146, 87, 205, 1) 80%, rgba(255, 78, 78, 1) 100%) text`};
    background-size: 200%;
    -webkit-text-fill-color: transparent;
    animation: animated-text ${props => `${10 / props.stripesSpeedMultiplier}s`} linear infinite;
  }

  .stripes-animation:hover span {
    -webkit-text-fill-color: ${props => props.isHover ? props.fontColorHover : ''}!important;
  }
`

export const CaptionContainer = props => {
  const Container = styled.div`
    position: absolute;
    transition: 0.15s;
    width: ${props.width}px !important;
    top: ${props.top}px;
    left: ${props.left}px;
    z-index: ${props.zIndex};

    &>p{
        background-color: ${props.backgroundColor};
        border-style: solid;
        border-color: ${props.borderColor};
        border-radius: ${props.borderRadius}px;
        border-width: ${props.borderWidth}px;
        color: ${props.color};
        font-family: ${props.fontFamily};
        font-size: ${Math.floor(props.fontSize)}px;
        font-style: ${props.fontStyle};
        font-weight: ${props.fontWeight};
        line-height: ${props.lineHeight / 100 * props.fontSize}px;
        margin: 0;
        padding: ${Math.floor(props.padding + props.diffBetwenFontSizeAndLineHeight)}px ${Math.floor(props.padding)}px;
        text-shadow: ${props.shadow};
        text-align: ${props.textAlign};
        text-transform: ${props.textTransform};
        letter-spacing: ${props.letterSpacing / 100}em;
        transition: 0.25s;
        word-wrap: anywhere;
        white-space: pre-wrap;

        opacity: 0;
        ${props.isLink ? 'cursor: pointer;' : ''}
    }

    &>p>span>span>span>span{
        text-decoration: ${props.underline}; 
    }

    &>p span{
        margin: 0px -0.1px;
        /* из-за этого трансишена при анимации слова переливаются как гирлянда */
        /* transition: all .3s ease; */
        
    }
    
    & .Typewriter__cursor{
      position:absolute;
    }

    & p.showTextAnyway span {
        visibility: visible !important;
        opacity: 1 !important;
    }
    & span.lightSpeedIn{
        
    }

    &:hover{
        & p{
            color:${props.isHover ? props.fontColorHover : props.color};
            background-color:${props.isHover ? props.backgroundColorHover : props.backgroundColor};
            border-color:${props.isHover ? props.borderColorHover : props.borderColor};
        }
    }
`

  return (
    <Container className={props.className} onClick={props.onClick} data-animation-in={props.animationIn || 'null'}>
      {props.children}
    </Container>

  )
}


export const ButtonContainer = styled.div`
    position: absolute;
    opacity: 0;

    &>p {
      /* библтотека hvr добаляет display: inline-block; что вызывает нежелательные отступы сверху и снизу в мобильном виде */
      display: block;
      /* задал ширину 100% т.к. контент кнопки не растягивался на всю кнопку */
      width: 100%;
      margin: 0;
      overflow: hidden;
      word-wrap: break-word;
      white-space: pre-wrap;
      /* opacity: 0; */
      /* transition: .5s; */
      /* обязательно указать названия свойств, чтобы не трогать opacity */
      transition-property: ${props => !props.isGradient ? 'color, border-color, transform, background' : 'color, border-color, transform'} ;
      transition-duration: .5s;
    }

    &>.button-text {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: 10;
      width: 100%;
      border: solid;
      border-color: transparent;
      pointer-events: none;
      overflow: hidden;
      transition: color .5s ease;
      white-space: pre-wrap;
      word-wrap: break-word;
    }

    .caption-content {
      color: ${props => props.textColor};
    }

      .caption-content:hover{
        background: ${props => ((props.hoverAnimationType != 'anti-hover' && props.hoverAnimationType != 'background') || !props.buttonAnimationOn) ? props.backgroundColorHover : ''}!important;
        border-color: ${props => props.borderColorHover}!important;
        color: ${props => props.textColorHover} !important;
      }
      .button-text {
        color: ${props => props.textColorHover}!important;
      }

    .caption-content::before{
      backface-visibility: hidden;
      background: ${props => {
    if (props.hoverAnimationType === 'background') {
      if (props.backgroundColorHover) {
        return props.backgroundColorHover
      } else {
        return '#2098D1'
      }
    } else {
      // на самом деле тут передаётся BGcolor который без ховера, 
      // т.к. псевдоэлемент расположен над BG и убирается по ховеру
      return props.backgroundColorHover
    }
  }}!important;
    }

    i {
      text-decoration: none !important;
    }

`

export const BoxContainer = styled.div`
    position: absolute;
    ${props => props.effectType === 'backdrop' && !props.hasCustomShape ? `backdrop-filter: blur(${props.glassEffect}px) invert(${props.invertEffect}) grayscale(${props.grayscaleEffect});` : ``}
    ${props => props.effectType === 'backdrop' ? `border-radius: ${props.borderRadius};` : ''}
    ${props => props.effectType === 'element' ? `filter: blur(${props.blur}px);` : ``}
    &>div{
        width: 100%;
        height: 100%;
        border: solid;
    }

    svg {
      ${props => `filter: blur(${props.effectType === 'backdrop' ? 0 : props.blur}px);`}
    }
`

export const CountdownContainer = styled.div`
  /* border: 1px solid red; */
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;
  &:hover{
    background-color: ${props => props.captionStyle.isHover ? props.captionStyle.backgroundColorHover : ''} !important;
    border-color: ${props => props.captionStyle.isHover ? props.captionStyle.borderColorHover : ''} !important;
    .contdown-item {
      color: ${props => props.captionStyle.isHover ? props.captionStyle.fontColorHover : ''};
    }
  }
`
export const CountdownList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* transition: transform 0.4s ease; */
  transition: top 0.4s ease;
  /* transition-property: transform; */
  /* transition-duration: 0.4s; */
`
export const CountdownItem = styled.div`
  flex: 1 0 100%;
  height: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
  color: ${props => props.color};
  overflow: hidden;
  transition: color 0.25s ease;
  padding: ${props => props.padding};
  display: flex;
  align-items: center;
  justify-content: ${props => props.justifyContent};
`
export const CountdownHidedList = styled.div`
  display: flex;
  width: 100%;
  visibility: hidden;
`
export const CountdownHidedItem = styled.div`
  flex: 1 0 100%;
  max-width: 100%;
  word-wrap: break-word;
  white-space: pre-wrap;
`